import PropTypes from 'prop-types';
import React from 'react';
import Select from 'react-select';
import cx from 'classnames';
import styles from './react-select-styles.scss';

const StyledSelect = (props) => {
  const { className, required, error, resetValue,
    label = '', matchProp = 'label', ...otherProps } = props;
  const resetValueSelect = resetValue || (otherProps.multi ? [] : '');
  const requiredText = required ? ' *' : '';
  const errorText = error || '';
  const classNames = cx({
    [styles.dropDownWrapper]: true,
    [className]: className,
  });
  const labelClassNames = cx({
    [styles.dropDownLabel]: true,
    [styles.errorText]: errorText,
  });
  const dropDownClassNames = cx({
    [styles.prettyDropDown]: true,
    [styles.errored]: errorText,
    [styles.empty]: props.value === '',
  });
  const errorMessageClassNames = cx({
    [styles.errorText]: errorText,
    [styles.errorMessage]: errorText,
  });
  return (<div className={classNames}>
    <label htmlFor="select" className={labelClassNames}>{label}{requiredText}</label>
    <Select
      matchProp={matchProp}
      {...otherProps}
      resetValue={resetValueSelect}
      className={dropDownClassNames}
    />
    <span className={errorMessageClassNames}>{errorText}</span>
  </div>);
};

StyledSelect.defaultProps = { clearable: true };

StyledSelect.propTypes = {
  className: PropTypes.string,
  required: PropTypes.bool,
  value: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
    PropTypes.bool,
    PropTypes.array, // Support multiple values
  ]),
  error: PropTypes.string,
  label: PropTypes.string,
  matchProp: PropTypes.string,
  resetValue: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.array,
    PropTypes.string,
  ]),
  isClearable: PropTypes.bool,
};

export default StyledSelect;



// WEBPACK FOOTER //
// ./client/app/shared/components/StyledSelect/react_select.jsx